<template>
  <div class="img-dialog" v-show="value"  @click="handleAction('confirm')">
    <img :src="img" />
  </div>
</template>
<script>
  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';

  export default create({
    name: 'ShareDialog',

    components: {},

    mixins: [Popup],

    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      img: {
        type: String,
        default: 'https://vipcdn.mgtv.com/upload3/201812/1207/share2.png'
      },
    },
    methods: {
      handleAction(action) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action);
      }
    },
    computed: {

    }
  });
</script>


<style lang="stylus" scoped>

  .img-dialog
    position: fixed;
    top: 0;
    right: 0;
    transition: .2s;
    img
      max-width 100%


</style>



// WEBPACK FOOTER //
// src/components/Popups/ShareDialog/ShareDialog.vue